<!-- 
<div class="filters" role="main" aria-label="Applications list page">
    <div class="searchCard app-list">
        <div class="searchCard">
         
            <div class="filter-field">
                <label [appTranslate]="'CHOOSE_PARKING_TYPE'"></label>
                <select type="text" name="parking" class="form-control-dropdown select-control"
                    [(ngModel)]="searchModel.ParkingTypeId" (change)="getPermitTypes()"
                    (ngSubmit)="getAllAplications()">
                    <option *ngFor="let item of parkingTypes" [value]="item.Id">{{item.Name}}</option>
                </select>
            </div>
            <div class="filter-field" *ngIf="searchModel.ParkingTypeId">
                <label [appTranslate]="'CHOOSE_LICENSE_TYPE'"></label>
                <select type="text" name="permit" class="form-control-dropdown select-control"
                    [(ngModel)]="searchModel.PermitTypeId" (ngSubmit)="getAllAplications()">
                    <option *ngFor="let item of permitTypes" [value]="item.PermitTypeId">{{item.Name}}</option>
                </select>
            </div>

            <div class="filter-field">
                <label [appTranslate]="'REGISTRATION'"></label>
                <input type="text" name="registration" class="form-control" [(ngModel)]="searchModel.Registration"
                    (ngSubmit)="getAllAplications()">
            </div>
            <div class="filter-field">
                <div style="display: flex;justify-content: space-between;width: 90%;">
                    <label [appTranslate]="'DATE_FROM'"> </label> <small *ngIf="InvalidDateFrom"
                        [appTranslate]="'INVALID_DATE'"></small>
                </div>
                <app-mat-datepicker-loc (dateSelected)="onDateSelectedFrom($event)"
                    #datepickerFrom></app-mat-datepicker-loc>

            </div>
            <div class="filter-field">
                <div style="display: flex;justify-content: space-between;width: 90%;">
                    <label [appTranslate]="'DATE_TO'"> </label>
                    <small *ngIf="InvalidDateTo" [appTranslate]="'INVALID_DATE'"></small>
                </div>
                <app-mat-datepicker-loc [minDate]="selectedDateFrom" (dateSelected)="onDateSelectedTo($event)"
                    #datepickerTo></app-mat-datepicker-loc>

            </div>

        </div>
        <div class="row">
            <div class="div-btn">
                <button type="button" class="round-btn clear" (click)="clearFilter()"><mat-icon aria-hidden="false"
                        fontIcon="refresh"></mat-icon></button>
                <button type="button" class="round-btn search" (click)="getAllAplications()"><mat-icon
                        aria-hidden="false" fontIcon="search"></mat-icon></button>
            </div>
        </div>
    </div>
</div>

<br>
<div style="margin: 0px 25px;">
    <h2 [appTranslate]="'REQUIREMENTS'"></h2>
    <table class="custom-table">
        <thead>
            <tr>
                <th><span [appTranslate]="'DATE'"></span></th>
                <th><span [appTranslate]="'APPLICATION_ID'"></span></th>
                <th><span [appTranslate]="'LICENSE_TYPE'"></span></th>
                <th><span [appTranslate]="'CITY'"></span></th>
                <th><span [appTranslate]="'LOCATION'"></span></th>
                <th><span [appTranslate]="'REGISTRATION'"></span></th>
                <th><span [appTranslate]="'STATUS'"></span></th>



                <th></th>

            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let app of applications">
                <td>{{app.DateCreated | date: 'dd.MM.YYYY HH:mm':'mk-MK'}}</td>
                <td>{{app.Id | slice:0:8}}</td>
                <td>{{app.PermitType}}</td>
                <td>{{app.City}}</td>
                <td>{{app.Location}}</td>
                <td style="text-align: center;display: inline;">
                    <div style="margin-bottom: 5px;" *ngFor="let item of app.VehicleRegistrations">
                        <b class="reg">{{item.Registration}}</b>
                    </div>
                </td>
                <td><span class="state {{app.Status}}">{{app.Status}}</span></td>
                <td>
                    <mat-icon class="more-btn" (click)="openDetails(app)" aria-hidden="false"
                        fontIcon="more_horiz"></mat-icon>
                </td>

            </tr>
        </tbody>
    </table>
    <div class="no-data">
        <small *ngIf="totalApplications==0" [appTranslate]="'NO_DATA'"></small>
    </div>
    <div class="col-lg-12 text-center" *ngIf="totalApplications!=0">
        <mat-paginator [length]="totalApplications" [pageIndex]="searchModel.Page - 1" [pageSize]="searchModel.Size"
            (page)="pageEvent($event)">
        </mat-paginator>
    </div>
    <div class="clearfix"></div>
</div>
<div class="loader" *ngIf="myLoaderService.isLoading | async"></div> -->
<div class="filters" role="main" aria-label="Applications list page">
    <h2 [appTranslate]="'REQUIREMENTS'"></h2>
    <div class="app-list">
        <div class="searchCard">
            <div class="filter-field">
                <label for="applications-parking-type" [appTranslate]="'CHOOSE_PARKING_TYPE'"></label>
                <select id="applications-parking-type" name="parkingType" class="form-control-dropdown" [(ngModel)]="searchModel.ParkingTypeId"
                    (change)="getPermitTypes()">
                    <option [ngValue]="null" disabled [appTranslate]="'CHOOSE_PARKING_TYPE'"></option>
                    <option *ngFor="let item of parkingTypes" [value]="item.Id">{{item.Name}}</option>
                </select>
            </div>

            <div class="filter-field" *ngIf="searchModel.ParkingTypeId">
                <label for="applications-license-type" [appTranslate]="'CHOOSE_LICENSE_TYPE'"></label>
                <select id="applications-license-type" name="licenseType" class="form-control-dropdown" [(ngModel)]="searchModel.PermitTypeId">
                    <option *ngFor="let item of permitTypes" [value]="item.PermitTypeId">{{item.Name}}</option>
                </select>
            </div>

            <div class="filter-field">
                <label for="applications-registration" [appTranslate]="'REGISTRATION'"></label>
                <input id="applications-registration" name="registration" type="text" class="form-control" [(ngModel)]="searchModel.Registration">
            </div>

            <div class="filter-field">
                <div>
                    <span [appTranslate]="'DATE_FROM'"></span>
                    <small *ngIf="InvalidDateFrom" [appTranslate]="'INVALID_DATE'"></small>
                </div>
                <app-mat-datepicker-loc (dateSelected)="onDateSelectedFrom($event)"></app-mat-datepicker-loc>
            </div>

            <div class="filter-field">
                <div>
                    <span [appTranslate]="'DATE_TO'"></span>
                    <small *ngIf="InvalidDateTo" [appTranslate]="'INVALID_DATE'"></small>
                </div>
                <app-mat-datepicker-loc [minDate]="selectedDateFrom"
                    (dateSelected)="onDateSelectedTo($event)"></app-mat-datepicker-loc>
            </div>
            <div class="filterBtns">
                <button type="button" class="round-btn clear" (click)="clearFilter()" aria-label="Clear filters">
                    <img src="/assets/images/refresh.svg" alt="" aria-hidden="true">
                </button>
                <button type="button" class="round-btn search" (click)="getAllAplications()" aria-label="Search applications">
                    <img src="/assets/images/search-normal.svg" alt="" aria-hidden="true">
                </button>
            </div>
        </div>
    </div>
</div>

<h2 [appTranslate]="'REQUIREMENTS'"></h2>

<table class="custom-table" *ngIf="totalApplications > 0">
    <thead>
        <tr>
            <th><span [appTranslate]="'APPLICATION_ID_TABLE'"></span></th>
            <th><span [appTranslate]="'LICENSE_TYPE'"></span></th>
            <th><span [appTranslate]="'CITY'"></span></th>
            <th><span [appTranslate]="'LOCATION'"></span></th>
            <th><span [appTranslate]="'REGISTRATION'"></span></th>
            <th><span [appTranslate]="'DATE'"></span></th>
            <th><span [appTranslate]="'STATUS'"></span></th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let app of applications">
            <td>{{app.Id | slice:0:8}}</td>
            <td>{{app.PermitType}}</td>
            <td>{{app.City}}</td>
            <td>{{app.Location}}</td>
            <td>
                <div *ngFor="let item of app.VehicleRegistrations">
                    <span class="reg">{{item.Registration}}</span>
                </div>
            </td>
            <td>{{app.DateCreated | date: 'dd.MM.YYYY HH:mm'}}</td>
            <td><span class="state state-{{app.StatusId}}">{{app.Status}}</span></td>
            <td>
                <button type="button" class="btn btn-more" (click)="openDetails(app)" aria-label="View application details">
                    <svg width="31" height="6" viewBox="0 0 31 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                            d="M3.00238 2.62477e-07L3.30567 0.0159627C4.80431 0.168113 5.97429 1.43312 5.97429 2.97191C5.97429 4.5107 4.80431 5.77571 3.30567 5.92786L3.00238 5.94382L2.97191 5.94382C1.33057 5.94382 -4.03303e-07 4.61325 -2.59813e-07 2.97191C-1.16322e-07 1.33057 1.33057 1.16322e-07 2.97191 2.59813e-07L3.00238 2.62477e-07ZM15.0221 1.31327e-06C16.6634 1.45676e-06 17.994 1.33057 17.994 2.97191C17.994 4.61325 16.6634 5.94382 15.0221 5.94382L14.9916 5.94382C13.3505 5.94356 12.0197 4.61309 12.0197 2.97191C12.0197 1.33073 13.3505 0.000256172 14.9916 1.31061e-06L15.0221 1.31327e-06ZM27.0418 2.36407e-06C28.6831 2.50756e-06 30.0137 1.33057 30.0137 2.97191C30.0137 4.61325 28.6831 5.94382 27.0418 5.94382L27.0127 5.94382C25.3714 5.94382 24.0408 4.61325 24.0408 2.97191C24.0408 1.33057 25.3714 2.21804e-06 27.0127 2.36153e-06L27.0418 2.36407e-06Z"
                            fill="#9CACB9" />
                    </svg>
                    <span [appTranslate]="'DETAILS'" class="visible-xs"></span>
                </button>
            </td>
        </tr>
    </tbody>
</table>
<div class="no-data" *ngIf="totalApplications==0">
    <small [appTranslate]="'NO_DATA'"></small>
</div>

<div class="col-lg-12 text-center" *ngIf="totalApplications!=0">
    <mat-paginator [length]="totalApplications"  [hidePageSize]="true" [pageIndex]="searchModel.Page - 1" [pageSize]="searchModel.Size"
        (page)="pageEvent($event)">
    </mat-paginator>
</div>

<div class="loader" *ngIf="myLoaderService.isLoading | async"></div>